import { observer } from 'mobx-react-lite';
import { PasswordField, SavingIndicator, TextField } from '../../../components';
import BunnyStorage from '../store/services/storages/BunnyStorage';

export default observer(function BunnyStorageForm({
  storage,
}: {
  storage: BunnyStorage;
}) {
  return (
    <>
      <TextField
        errorText={storage.errors.storageZoneName}
        label="Storage Zone Name"
        name="storageZoneName"
        onBlur={storage.handleBlur}
        onChange={storage.handleChange}
        sx={{ width: '80%' }}
        value={storage.storageZoneName}
      />
      <PasswordField
        errorText={storage.errors.apiPassword}
        helperText="The same as your storage zone password"
        label="API Key"
        name="apiPassword"
        onBlur={storage.handleBlur}
        onChange={storage.handleChange}
        required
        sx={{ width: '80%' }}
        value={storage.apiPassword}
      />
      <TextField
        errorText={storage.errors.apiRegion}
        label="Region (optional)"
        name="apiRegion"
        onBlur={storage.handleBlur}
        onChange={storage.handleChange}
        sx={{ width: '80%' }}
        value={storage.apiRegion}
      />

      <SavingIndicator indicator={storage.indicator} sx={{ mt: 2 }} />
    </>
  );
});
